import type { TFunction } from 'i18next';
import { ApiError } from './api';

/** Customer-facing text for booking API errors; airline rejections map to a localized reason. */
export function bookingErrorText(err: unknown, t: TFunction): string {
  if (err instanceof ApiError && err.code) {
    if (err.code === 'NRS_REJECTED') {
      const reason = (err.details as { reason?: string } | undefined)?.reason ?? 'OTHER';
      return t(`common.nrsReasons.${reason}`, { defaultValue: t('common.nrsReasons.OTHER') });
    }
    const known = t(`common.apiErrors.${err.code}`, { defaultValue: '' });
    if (known) return known;
  }
  return err instanceof Error && err.message ? err.message : t('common.errorGeneric');
}
